import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorService } from 'src/app/services/behaviour.service';
import { CommonService } from 'src/app/services/common.service';
import { LoaderModalService } from 'src/app/services/loader.service';
import { IMonth, IYear } from 'src/app/start/sidenav/sidenav.component';

@Component({
  selector: 'app-add-credit-card',
  templateUrl: './add-credit-card.component.html',
  styleUrls: ['./add-credit-card.component.css']
})
export class AddCreditCardComponent implements OnInit {
  CreditCardForm_login: FormGroup
  cardImage: any = '';
  auth: any;
  submitted: boolean = false;
  years: IYear[] = [];
  monthlist: IMonth[] = [];
  statelist: IMonth[] = [];
  userData: any = ''

  year: any;
  month: any
  isBrowser: boolean
  constructor(
    private fb: FormBuilder,
    private userDashboardSrv: CommonService,
    private ls: LoaderModalService,
    private _bs: BehaviorService,
    @Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);

    this.initalizeCreditcard_loginForm()
  }

  ngOnInit(): void {
    this.GetYears();
    this.GetMonths();
    this.GetStateList();
    this.getUserData()
  }
  getUserData() {
    if (!this.isBrowser) return
    this.userDashboardSrv.getUserProfile(localStorage.getItem('covaUserId')).subscribe((res: any) => {
      if (res["meta"]["status"]) {
        this.userData = res.data
      }
    })
    return
  }

  GetMonths() {
    this.monthlist = [];
    for (let i = 1; i <= 12; i++) {
      this.month = <IMonth>{};
      if (i.toString().length == 1) {
        this.month.text = i.toString();
        this.month.value = i.toString();
      } else {
        this.month.text = i.toString();
        this.month.value = i.toString();
      }

      this.monthlist.push(this.month);
    }
  }
  GetYears() {
    this.years = [];
    let year = new Date().getFullYear();
    for (let i = year; i <= year + 20; i++) {
      this.year = <IYear>{};
      this.year.text = i.toString();
      this.year.value = i.toString();
      this.years.push(this.year);
    }
  }
  initalizeCreditcard_loginForm() {
    this.CreditCardForm_login = this.fb.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      phone: ["", [Validators.required, Validators.minLength(10)]],
      email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      cardNum: ["", [Validators.required, Validators.minLength(16), Validators.maxLength(16), Validators.pattern("^((\\+91-?)|0)?[0-9]{16}$")]],
      month: ["", [Validators.required]],
      year: ["", [Validators.required]],
      cvv: ["", [Validators.required,]],
      street: ["", [Validators.required]],
      apartment: ["", ""],
      isDefault: [false],
      city: ["", [Validators.required]],
      state: ["", [Validators.required]],
      country: ["CA", [Validators.required]],
      zip: ["", [Validators.required, Validators.pattern(/[0-9a-zA-Z]{6,}/)]],
    });
  }
  cvvInput(e) {

  }

  get f() { return this.CreditCardForm_login.controls }

  onSubmit() {


    this.submitted = true
    if (this.CreditCardForm_login.invalid) {
      return
    }
    if (this.CreditCardForm_login.value.cvv.length < 3) {
      return
    }
    this.ls.startLoader('', '');
    this.CreditCardForm_login.value.cvv = ''

    this.userDashboardSrv.Post('/users/addusercardinfo', this.CreditCardForm_login.value).subscribe(res => {
      if (res['meta']['status']) {
        this.ls.changeStateandStopLoader("success", res['meta']['msg'], 2000)
        this._bs.set('card')
        this.submitted = false;

      } else {
        this.ls.changeStateandStopLoader("error", res['meta']['msg'], 2000)

      }
    })
  }

  GetStateList() {
    this.statelist = [];
    this.month = <IMonth>{};
    this.month.text = 'Alberta';
    this.month.value = 'AB';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'British Columbia';
    this.month.value = 'BC';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Manitoba';
    this.month.value = 'MB';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'New Brunswick';
    this.month.value = 'NB';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Newfoundland';
    this.month.value = 'NL';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Northwest Territories';
    this.month.value = 'NT';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Nova Scotia';
    this.month.value = 'NS';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Nunavut';
    this.month.value = 'NU';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Ontario';
    this.month.value = 'ON';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Prince Edward Island';
    this.month.value = 'PE';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Quebec';
    this.month.value = 'QC';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Saskatchewan';
    this.month.value = 'SK';
    this.statelist.push(this.month);
    this.month = <IMonth>{};
    this.month.text = 'Yukon';
    this.month.value = 'YT';
    this.statelist.push(this.month);

  }
  firstLaterCaps(event) {
    const str = event.target.value;
    const str2 = str.charAt(0).toUpperCase() + str.slice(1);
    return event.target.value = str2
  }

  spaceNotAllowed(e) {
    const charCode = e.which ? e.which : e.keyCode;

    if (charCode == 32) {
      return false;

    }
    else {
      return true
    }
  }


  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData
    let pastedText = clipboardData.getData('text');
    this.CreditCardForm_login.patchValue({
      zip: pastedText.split(" ").join('').toUpperCase()
    })
  }
  lettersOnly(event) {
    const str = event.target.value;
    const str2 = str.charAt(0).toUpperCase() + str.slice(1);
    event.target.value = str2
    var charCode = event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8)

      return true;
    else
      return false;
  }
  onKeypressing(e) {
    //(e, 'evtttttt');

    const charCode = e.which ? e.which : e.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;

    }
    else {
      return true
    }
  }

  GetCardType(number: any) {
    if (number?.length < 15) {
      this.cardImage = ''
      return
    }
    let value: any
    var re = new RegExp("^4");
    if (number?.match(re) != null) {
      value = "Visa";
      return this.cardImage = 'assets/images/visa.png'
    }
    if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) {
      value = "Mastercard";
      return this.cardImage = 'assets/images/mastercard.png'
    }
    re = new RegExp("^3[47]");
    if (number?.match(re) != null) {

      value = "AMEX";
      return this.cardImage = 'assets/images/amex.png'
    }
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number?.match(re) != null) {

      value = "Discover";
      return this.cardImage = 'assets/images/discover.png'

    }
    re = new RegExp("^36");
    if (number?.match(re) != null) {
      value = "Diners";
      return this.cardImage = 'assets/images/diners.png'
    }
    re = new RegExp("^30[0-5]");
    if (number?.match(re) != null) {
      value = "Diners - Carte Blanche";
      return this.cardImage = 'assets/images/diners.png'
    }
    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number?.match(re) != null) {

      value = "JCB";
      return this.cardImage = 'assets/images/jcb.png'

    }

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number?.match(re) != null) {
      value = "Visa Electron";
      return this.cardImage = 'assets/images/visa.png'
    }
    if (number == '') {
      return this.cardImage = ''
    }


  }

  onKeyUp(x, val2) { // appending the updated value to the variable

    x.target.value = x.target.value.toLocaleUpperCase();

    if (this.auth) {
      // this.creditCardonkey_errorhandler_login(val2)
    } else {
      // this.creditCardonkey_errorhandler(val2)
    }
  }
}
